import { render, staticRenderFns } from "./index_f.vue?vue&type=template&id=2dd21b61&scoped=true"
import script from "./index_f.vue?vue&type=script&lang=js"
export * from "./index_f.vue?vue&type=script&lang=js"
import style0 from "./index_f.vue?vue&type=style&index=0&id=2dd21b61&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd21b61",
  null
  
)

export default component.exports